module.exports = "/packs/course-small-sns-marketing-6625fb51edc069237565ba4cb4c3282c.png";